import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgReceipt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#3A3247",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 6.756v13.427l2-1.202 2.001 1.101L12 18.981l2 1.101 2-1.101 2.001 1.101V6.756zm3.001 5.11H15V9.861H9.001zm0 4.01H15v-2.005H9.001zM4 5.854h16V3.85H4z",
  clipRule: "evenodd"
})));

export { SvgReceipt as ReactComponent };
//# sourceMappingURL=Receipt.svg.js.map
